import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { CustomerActionCreator, VehiclesActionCreator, NewVehicleActionCreator, AppointmentActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator, MenusActionCreator, FrameworkActionCreator } from 'src/store/states';
import ChangePassword from 'src/components/ChangePassword/ChangePassword';

const mapStateToProps = (state: IStoreState) => ({
    custInfo: state.Customer!['Customer'],
    profileNum: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    theme: state.Framework.theme,
    locale: state.Framework.locale,
    identityVerified: state.Customer.identityVerified,
});

const mapDispatchToProps = {
    sendResetEmail: CustomerActionCreator.SendResetEmail,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearMenusState: MenusActionCreator.ClearMenusState,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    waitForLogOff: CustomerActionCreator.WaitForLogOff,
    logCustOff: CustomerActionCreator.LogCustOff,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ChangePassword);